import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TableModule } from 'primeng/table';
import { AddressModule } from '../../../address/address.module';
import { CorrespondenceNoSearchModule } from '../../../correspondence/correspondence-no-search.module';
import { DisbursementRequestModule } from '../../../finance/disbursement/request/disbursement-request.module';
import { DisbursementSummaryModule } from '../../../finance/disbursement/summary/disbursement-summary.module';
import { NoteModule } from '../../../note/note.module';
import { SharedComponentsModule } from '../../../shared/components/shared-components.module';
import { VehicleInformationCoreModule } from '../../../vehicle/components/shared/vehicle/vehicle-information/vehicle-information-core.module';
import { CustomerAccountModule } from '../../account/customer-account.module';
import { HistoricalCustomerAddressModule } from '../../address/historical-customer-address.module';
import { CustomerAffiliationModule } from '../../affiliation/customer-affiliation.module';
import { CustomerCharacteristicModule } from '../../characteristic/customer-characteristic.module';
import { HistoricalCustomerCharacteristicModule } from '../../characteristic/historical-customer-characteristic.module';
import { CustomerContactModule } from '../../contacts/customer-contact.module';
import { CustomerFleetModule } from '../../fleet/customer-fleet.module';
import { CustomerIdentificationModule } from '../../identification/customer-identification.module';
import { HistoricalCustomerIdentificationModule } from '../../identification/historical-customer-identification.module';
import { CustomerInsuranceModule } from '../../insurance/customer-insurance.module';
import { CustomerNamesModule } from '../../name/customer-names.module';
import { CustomerRepresentativeModule } from '../../representative/customer-representative.module';
import { ServiceHistoryModule } from '../../service-history/service-history.module';
import { CustomerPipeModule } from '../../shared/pipes/customer-pipe.module';
import { CustomerVehicleModule } from '../../vehicle/customer-vehicle.module';
import { OrganizationCustomerDetailsComponent } from './organization-customer-details.component';
import { OrganizationCustomerComponent } from './organization-customer.component';
import { OrganizationDetailModalComponent } from './organization-customer-details-modal.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomerPlacardModule } from '../../../customer/placard/customer-placard.module';

@NgModule({
    declarations: [
        OrganizationCustomerComponent,
        OrganizationCustomerDetailsComponent,
        OrganizationDetailModalComponent
    ],
    providers: [],
    imports: [
        AddressModule,
        CommonModule,
        CorrespondenceNoSearchModule,
        CustomerAccountModule,
        CustomerAffiliationModule,
        CustomerCharacteristicModule,
        CustomerContactModule,
        CustomerFleetModule,
        CustomerIdentificationModule,
        CustomerPlacardModule,
        CustomerInsuranceModule,
        CustomerNamesModule,
        CustomerPipeModule,
        CustomerRepresentativeModule,
        CustomerVehicleModule,
        DisbursementRequestModule,
        DisbursementSummaryModule,
        HistoricalCustomerAddressModule,
        HistoricalCustomerCharacteristicModule,
        HistoricalCustomerIdentificationModule,
        NoteModule,
        ServiceHistoryModule,
        SharedComponentsModule,
        TableModule,
        VehicleInformationCoreModule,
        FormsModule.withConfig({callSetDisabledState: 'whenDisabledForLegacyCode'}),
        ReactiveFormsModule
    ],
    exports: [
        OrganizationCustomerComponent,
        OrganizationCustomerDetailsComponent
    ]
})
export class OrganizationCustomerModule {
}
